import { render, staticRenderFns } from "./MtiporesolucionModals.vue?vue&type=template&id=faaf28d6"
import script from "./MtiporesolucionModals.vue?vue&type=script&lang=js"
export * from "./MtiporesolucionModals.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports